import { format, isValid, parseISO } from 'date-fns'
import React from 'react'
import { calculateAverageLessonsPerMonth, calculateTeacherRating, calculateTeachersChurn, tallyTotalLessons } from './utilityFunctions'

const AdminTeacherCard = (props) => {
    const [bkgd, setBkgd] = React.useState(false)
    const [averageLessonsPerMonth, setAverageLessonsPerMonth] = React.useState(0)
    const [churn, setChurn] = React.useState(0)
    const [totalLessons, setTotalLessons] = React.useState(0)
    const [teacherRating, setTeacherRating] = React.useState(0)

    React.useEffect(() => {
        if(props.teacher.BackgroundCheck) {
            props.teacher.BackgroundCheck === 'verified' ? setBkgd(true) : setBkgd(false)
        } else {
            setBkgd(false)
        }
    }, [])

    React.useEffect(() => {
        setAverageLessonsPerMonth(calculateAverageLessonsPerMonth(props.teacher.TeacherID, props.timesheets))
        setChurn(calculateTeachersChurn(props.teacher.TeacherID, props.timesheets))
        setTeacherRating(calculateTeacherRating(props.teacher.TeacherID, props.timesheets))
        setTotalLessons(tallyTotalLessons(props.teacher.TeacherID, props.timesheets))
    }, [props.timesheets])

    React.useEffect(() => {
        changeBubbleColor(averageLessonsPerMonth, 1, 5)
        changeChurnBubbleColor(churn)
    }, [averageLessonsPerMonth])

    function changeBubbleColor(numberValue, min, max) {
        // Define the minimum and maximum values for the scale
        const minValue = min;
        const maxValue = max;
      
        // Calculate the color based on the number value
        let color;
        if (numberValue === maxValue) {
          color = "#00FF00"; // Green color for the best number (4)
        } else if (numberValue >= minValue && numberValue < maxValue) {
          const red = Math.round((maxValue - numberValue) * 255 / 3); // Gradually decrease the red value
          const green = Math.round((numberValue - minValue) * 220 / 3); // Gradually increase the green value
          color = `rgb(${red}, ${green}, 0)`; // Combine red and green values
        } else {
          color = "#FF0000"; // Red color for the warning number (1)
        }
      
        // Set the bubble's color
        const bubble = document.getElementById(`average-lessons-per-month-${props.teacher.TeacherID}`); // Replace 'bubble' with the ID of your bubble element
        if(bubble) {
            bubble.style.backgroundColor = color;
        }   
      }

      function changeChurnBubbleColor(numberValue) {
        let color;
        if (numberValue <= 50) {
          const green = Math.round((numberValue / 55) * 220); // Gradually increase the green value
          const red = 220 - green; // Decrease the red value based on the green value
          color = `rgb(${green}, ${red}, 0)`; // Combine red and green values
        } else {
          color = "rgb(255, 0, 0)"; // Red color for any number over 50
        }
      
        // Set the bubble's color
        const bubble = document.getElementById(`churn-bubble-${props.teacher.TeacherID}`); // Replace 'bubble' with the ID of your bubble element
        if(bubble) {
            bubble.style.backgroundColor = color;
        }
      }
      
      
      

    if(props.teacher.School !== 'admin') {
        return (
            <div className="admin-teacher-card" id={`admin-teacher-card-${props.teacher.TeacherID}`} onClick={() => props.openModal(props.teacher)}>
                {props.teacherStatus === 'goon' &&
                    <img className='goon-mode__drake' src='./drake.jpg' />
                }
                {props.teacherStatus === 'leaving' &&
                    <div className='leaving-mode__label'>
                        <div>LEAVING</div>
                        {isValid(new Date(parseISO(props.teacher.DepartureDate))) && <div>{format(new Date(parseISO(props.teacher.DepartureDate)), 'MMMM dd, yyyy')}</div>}
                    </div>
                }
                {
                    props.teacherStatus === 'Left School' || props.teacherStatus === 'goon' || props.teacherStatus === 'leaving' ? 
                    <div className="admin-teacher-card-pic" style={{opacity: 0.3, backgroundImage: 'url(https://app.atharo.app/images/' + props.teacher.ImageName + ')'}}></div>
                    :
                    <div className="admin-teacher-card-pic" style={{opacity: 1, backgroundImage: 'url(https://app.atharo.app/images/' + props.teacher.ImageName + ')'}}></div>
                }
                {props.teacher.newStudentList && props.teacher.newStudentList.length > 0 ? <div className="student-number-bubble">{props.teacher.newStudentList.length}</div> : null}
                {!isNaN(averageLessonsPerMonth) && <div className='total-lessons-bubble'>{totalLessons} TLT</div>}
                {!isNaN(averageLessonsPerMonth) && <div className='average-lessons-bubble' id={`average-lessons-per-month-${props.teacher.TeacherID}`}>{averageLessonsPerMonth} LPM</div>}
                {!isNaN(averageLessonsPerMonth) && <div className='churn-bubble' id={`churn-bubble-${props.teacher.TeacherID}`}>{churn}% CRN</div>}

                {/* {!isNaN(averageLessonsPerMonth) && <div className='churn-bubble' id={`churn-bubble-${props.teacher.TeacherID}`}>{teacherRating}</div>} */}
                { !props.teacher.WantsMoreStudents &&
                    <div className="no-more-students__hand">
                        <img src="stop-hand.svg"/>
                    </div>
                }
                { props.teacher.BackgroundCheck === 'verified' &&
                    <div className="background-check-checkmark" style={{backgroundColor: "green"}}>
                        <img className="background-check-icon" src="check.svg"/>
                    </div>
                }
                { props.teacher.BackgroundCheck === 'ordered' &&               
                    <div className="background-check-checkmark" style={{backgroundColor: "yellow"}}>
                        <img className="background-check-icon" src="phone.svg"/>
                    </div>
                }
                { props.teacher.BackgroundCheck === 'pending' &&               
                    <div className="background-check-checkmark" style={{backgroundColor: "rgb(182, 118, 0)"}}>
                        <img className="background-check-icon" src="question.svg"/>
                    </div>
                }
                <div className="admin-teacher-card-name">{props.teacher.Name}</div>
            </div>
        )
    } else {
        return null
    }
}
export default AdminTeacherCard